import moment from 'moment-timezone';
import React, { useEffect, useState } from 'react';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import infoimg from '../assets/img/information.png';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#676666',
      color: '#ffffff',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
    },
  }));

const Timer = ({ startDateTime, downloadFile, handleDownloadFile, stuid, formId, handleTimerComplete, handleReqFormDownload }) => {
    //startDateTime = '2024-06-03T10:39:00.634Z'; //static for testing
    const durationMin = 30;
    const duration = moment.duration(durationMin, 'minutes');

    const [timeLeft, setTimeLeft] = useState(() => {
        const start = moment(startDateTime);
        const end = moment(start).add(duration);
        return moment.duration(end.diff(moment()));
    });


    useEffect(() => {
        const start = moment(startDateTime);
        const end = moment(start).add(duration);

        const interval = setInterval(() => {
            const now = moment();
            const newTimeLeft = moment.duration(end.diff(now));

            if (newTimeLeft.asMilliseconds() <= 0) {
                setTimeLeft(moment.duration(0));
                clearInterval(interval);
                handleTimerComplete();
            } else {
                setTimeLeft(newTimeLeft);
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [startDateTime]);

    return (
        <>
            <a title="Download"
                onClick={(e) => handleDownloadFile(stuid, formId, downloadFile)}
                target="_blank" class="btn btn-cancel btn-login btn-down"><PictureAsPdfIcon />Form Download</a>
            {/*{
                timeLeft.asMilliseconds() > 0 ?
                    <>
                        <a title="Download"
                            onClick={(e) => handleDownloadFile(stuid, formId, downloadFile)}
                            target="_blank" class="btn btn-cancel btn-login btn-down"><PictureAsPdfIcon />Form Download</a>
                        <HtmlTooltip
                            title={
                                <React.Fragment>
                                    <Typography color="inherit" >Download is available for 30 mins, please hurry.</Typography>
                                </React.Fragment>
                            }
                        >
                            <img src={infoimg} className="tolps" />
                        </HtmlTooltip>
                        <div className='timer_container'>
                            <h5>TIME REMAINING</h5>
                            <div className='d-flex justify-content-between'>
                                <div className='timer_item'>
                                    <div className='timer d-flex justify-content-center align-items-center'>
                                        {String(timeLeft.minutes()).padStart(2, '0')}
                                    </div>
                                    <div className='timer_text'>
                                        MINUTES
                                    </div>
                                </div>
                                <div className='timer_item'>
                                    <div className='timer d-flex justify-content-center align-items-center'>
                                        {String(timeLeft.seconds()).padStart(2, '0')}
                                    </div>
                                    <div className='timer_text'>
                                        SECONDS
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                    :
                    <div className='timer_container w-100'><span onClick={handleReqFormDownload} style={{ color: "#0d6efd" }} role="button">Click here</span> to request Form Download</div>
            }*/}
        </>
    );


}

export default Timer;
